import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface ShopifyLink {
  forceRedirect?: boolean;
  path: string;
  shopifyLink: string;
}

@Injectable({ providedIn: 'root' })
export class ShopifyMigrationService {
  private shopifyLinks$: Observable<ShopifyLink[]>;

  constructor(
    private http: HttpClient
  ) {}

  getShopifyLinks() {
    if (!this.shopifyLinks$) {
      this.shopifyLinks$ = this.http.get<ShopifyLink[]>(
        environment.shopifyMigration.getShopifyLinks
      ).pipe(
        shareReplay(1)
      );
    }

    return this.shopifyLinks$;
  }

  updateShopifyLink(link: ShopifyLink) {
    return this.http.post(environment.shopifyMigration.updateShopifyLink, link).pipe(
      tap(() => {
        this.shopifyLinks$ = undefined;
      })
    );
  }
}
